import React from "react";
import { Button, Checkbox, Col, Flex, Form, Input, Row, Space } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

export const DomainFields: React.FC = () => (
  <Row gutter={16}>
    <Col span={12}>
      <Form.Item label="Code" name="code" rules={[{ required: true }]}>
        <Input placeholder="sat_student" />
      </Form.Item>
    </Col>
    <Col span={12}>
      <Form.Item label="Name" name="name" rules={[{ required: true }]}>
        <Input placeholder="SAT Student Site" />
      </Form.Item>
    </Col>
    <Col span={24}>
      <Form.Item
        label="Redirect URL"
        name="url"
        rules={[{ required: true, type: "url", message: "Valid URL kiriting." }]}
      >
        <Input placeholder="https://dev-1600.satashkent.uz" />
      </Form.Item>
    </Col>
    <Col span={24}>
      <Form.Item
        label="Additional allowed origins"
        tooltip="Extra origins that can be used as redirect_uri (e.g. http://localhost:3200 for local dev)."
      >
        <Form.List name="allowedRedirectOrigins">
          {(fields, { add, remove }) => (
            <Flex vertical gap={8}>
              {fields.map(({ key, ...field }) => (
                <Space.Compact key={key} style={{ width: "100%" }}>
                  <Form.Item
                    {...field}
                    noStyle
                    rules={[
                      { required: true, message: "URL required" },
                      { type: "url", message: "Not a valid URL" },
                    ]}
                  >
                    <Input placeholder="http://localhost:3200" />
                  </Form.Item>
                  <Button
                    danger
                    icon={<MinusCircleOutlined />}
                    onClick={() => remove(field.name)}
                    aria-label="Remove origin"
                  />
                </Space.Compact>
              ))}
              <Button
                type="dashed"
                onClick={() => add("")}
                icon={<PlusOutlined />}
                block
              >
                Add origin
              </Button>
            </Flex>
          )}
        </Form.List>
      </Form.Item>
    </Col>
    <Col span={24}>
      <Form.Item label="Description" name="description">
        <Input.TextArea rows={3} />
      </Form.Item>
    </Col>
    <Col span={12}>
      <Form.Item label="Icon" name="icon">
        <Input placeholder="ST" />
      </Form.Item>
    </Col>
    <Col span={12}>
      <Form.Item name="isActive" valuePropName="checked" style={{ marginTop: 30 }}>
        <Checkbox>Active</Checkbox>
      </Form.Item>
    </Col>
  </Row>
);
